import { uuid } from 'uuidv4';
let eventGuid = uuid();
let todayStr = new Date().toISOString().replace(/T.*$/, '') // YYYY-MM-DD of today

export const INITIAL_EVENTS = [
  // {
  //   id: createEventId(),
  //   title: 'All-day event',
  //   start: todayStr
  // },
  // {
  //   id: createEventId(),
  //   title: 'Timed event',
  //   start: todayStr + 'T12:00:00'
  // },
  {
    title     : 'Available',
    start     : '2021-05-25 00:00:00',
    end     : '2021-05-27 24:00:00',
    className : 'available',
  },
  {
    title     : 'Not Available',
    start     : '2021-05-26 12:00:00',
    end     : '2021-05-26 14:00:00',
    className : 'not-available',
  },
  {
    title  : 'Not Available',
    start  : '2021-05-28 09:30:00',
    end    : '2021-05-28 17:30:00',
    className : 'not-available',
  }
]

export function createEventId() {
  return String(eventGuid + + Math.round(new Date() / 1000))
}